module.exports = __webpack_public_path__ + "img/PT35.cf355e5e.png";